import { render } from "./HorsePreviewOtherData.vue?vue&type=template&id=5796d935"
import script from "./HorsePreviewOtherData.vue?vue&type=script&lang=js"
export * from "./HorsePreviewOtherData.vue?vue&type=script&lang=js"

import "./HorsePreviewOtherData.vue?vue&type=style&index=0&id=5796d935&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__